import React from 'react';
import classNames from 'classnames';
import { assertValidState } from './helper';

export type ValidationState = 'success' | 'warning' | 'error';

export interface ValidationMessageProps
  extends React.HTMLAttributes<HTMLElement> {
  validationState?: ValidationState;
  className?: string;
}

const ValidationMessage: React.FunctionComponent<ValidationMessageProps> = ({
  validationState = undefined,
  className,
  children,
  ...otherProps
}) => {
  assertValidState(validationState);

  return validationState && children ? (
    <span
      className={classNames('input__validation', className)}
      {...otherProps}
    >
      {children}
    </span>
  ) : null;
};

export default ValidationMessage;
